export default "__VITE_ASSET__D3j8X7ok__"